import platformUtilities from '../modules/platform_utilities.js';

$(document).on('turbo:load', function() {
  $('table').on('draw.dt', platformUtilities.initSvgFontAwesomeIcons);

  platformUtilities.initSvgFontAwesomeIcons();
});